import React, { useEffect, useState } from "react";
import { Link, useLocation } from "react-router-dom";
import logo from "../../img/logo.svg";
const Navbar = () => {
	const location = useLocation();
	const [pathname, setPathname] = useState("/");
	useEffect(() => {
		console.log("location=> ", location);
		setPathname(location.pathname);
	}, [location]);
	return (
		<div className="navbar-container">
			<div className="logo">
				<img src={logo} alt="Logo" srcSet="" />
				<div className="data">
					<p className="name">JoseCortez1</p>
					<p className="job">Software Engineer</p>
				</div>
			</div>

			<nav className="nav-container">
				<Link
					to="/"
					className={`item-navbar  ${pathname === "/" ? "active" : ""}`}>
					Home
					<div></div>
				</Link>
				<Link
					to="/projects/"
					className={`item-navbar  ${
						pathname === "/projects/" ? "active" : ""
					}`}>
					Projects
					<div></div>
				</Link>

				<Link
					to="/contact/"
					className={`item-navbar  ${
						pathname === "/contact/" ? "active" : ""
					}`}>
					Contact
					<div></div>
				</Link>
				<Link
					to="/cv/"
					className={`item-navbar  ${pathname === "/cv/" ? "active" : ""}`}>
					CV
					<div></div>
				</Link>
			</nav>
		</div>
	);
};

export default Navbar;
